(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dynamic-logo-list-collapse"] && !Shopify.designMode) return;
  try {
    
  const collapseContainer = document.querySelector('.collapse-container');
  const collapseButton = document.querySelector('.collapse-header .collapse--button');
  
  collapseContainer.style.display = 'none';
  
  collapseButton.addEventListener('click', () => {
      if (collapseContainer.style.display === 'none') {
          collapseContainer.style.display = 'block';
          collapseButton.textContent = 'Ver menos';
  
          collapseContainer.classList.add('slide-in-up');
          collapseContainer.addEventListener('animationend', () => {
              collapseContainer.classList.remove('slide-in-up');
          });
      } else {
          collapseContainer.style.display = 'none';
          collapseButton.textContent = 'Ver más';
  
          collapseContainer.classList.add('slide-out-down');
          collapseContainer.addEventListener('animationend', () => {
              collapseContainer.classList.remove('slide-out-down');
          });
      }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pxu-slideshow"] && !Shopify.designMode) return;
  try {
    
const { Section, Carousel } = window.PxuThemeSections;

class SlideshowSection extends Section {
  constructor($root) {
    super($root);
    this.$root = $root;
    this.id = $root.id;
    this.data = this.loadData();
    this.autoplay = this.data.autoplay;
    this.autoplayDuration = this.data.autoplayDuration * 1000;
    this.carousel = null;

    this.onMount();
  }

  onMount() {
    const options = {
      autoPlay: this.autoplay ? this.autoplayDuration : false,
      prevNextButtons: true,
      lazyLoad: true
    };

    const mobileOptions = {
      draggable: true,
      autoPlay: this.autoplay ? this.autoplayDuration : false,
      lazyLoad: true
    };

    this.carousel = new Carousel(this.$root, options, mobileOptions);
    this.carousel.onMount();
  }

  onUnmount() {
    this.carousel.onUnmount();
    this.carousel = null;
  }

  onBlockSelect(event) {
    if (!this.carousel) return;
    const $slide = event.target.parentElement;
    this.carousel.selectSlide($slide);
  }
}

document.querySelectorAll('[data-pxu-slideshow]').forEach(($section) => {
  Section.init($section, SlideshowSection);
});

// export class for theme editor instance management
if (Shopify.designMode) {
  window.PxuThemeSections.SlideshowSection = SlideshowSection;
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-store-locator"] && !Shopify.designMode) return;
  try {
    
(() => {
  let googleMapsPromise;
  const normalize = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function mapsLibrary(key) {
    if (window.google && window.google.maps && window.google.maps.Map) return Promise.resolve(window.google.maps);
    if (googleMapsPromise) return googleMapsPromise;
    googleMapsPromise = new Promise((resolve, reject) => {
      const existing = document.querySelector('script[src*="maps.googleapis.com/maps/api/js"]');
      let checks = 0;
      const ready = () => {
        if (window.google && window.google.maps && window.google.maps.Map) { resolve(window.google.maps); return; }
        if (++checks > 100) { reject(new Error('Maps not ready')); return; }
        window.setTimeout(ready, 150);
      };
      if (existing) { ready(); return; }
      if (!key) { reject(new Error('Map configuration unavailable')); return; }
      const script = document.createElement('script');
      script.src = 'https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(key) + '&loading=async&language=es&region=PY&v=weekly&callback=__tlBranchesMapsReady';
      script.async = true;
      window.__tlBranchesMapsReady = ready;
      script.onerror = () => reject(new Error('Map could not load'));
      document.head.appendChild(script);
      ready();
    });
    return googleMapsPromise;
  }
  function initialize(root) {
    if (root.dataset.locatorInitialized === 'true') return;
    root.dataset.locatorInitialized = 'true';
    root.dataset.view = 'list';
    const cards = [...root.querySelectorAll('[data-store-card]')];
    const stores = cards.map(card => ({
      card, id: card.dataset.storeId, name: card.dataset.storeName, code: card.dataset.storeCode,
      region: card.dataset.storeRegion, address: card.dataset.storeAddress,
      lat: Number(card.dataset.storeLat), lng: Number(card.dataset.storeLng),
      search: normalize(card.dataset.storeName + ' ' + card.dataset.storeCode + ' ' + card.dataset.storeAddress)
    }));
    const search = root.querySelector('[data-store-search]');
    const empty = root.querySelector('[data-store-empty]');
    const count = root.querySelector('[data-store-count]');
    const mapBox = root.querySelector('[data-store-map]');
    const mapStatus = root.querySelector('[data-map-status]');
    const selectedPanel = root.querySelector('[data-map-selected]');
    let zone = 'all', visible = [...stores], selected = stores[0], map, maps, loading = false;

    function selectStore(store, options = {}) {
      if (!store) { selectedPanel.hidden = true; return; }
      selected = store;
      stores.forEach(s => s.card.classList.toggle('is-selected', s.id === store.id));
      root.querySelector('[data-map-selected-code]').textContent = store.code;
      root.querySelector('[data-map-selected-name]').textContent = store.name;
      root.querySelector('[data-map-selected-address]').textContent = store.address;
      selectedPanel.hidden = !map;
      if (map) {
        map.data.revertStyle();
        const feature = map.data.getFeatureById(store.id);
        if (feature) map.data.overrideStyle(feature, { icon: { path: maps.SymbolPath.CIRCLE, scale: 11, fillColor: '#111111', fillOpacity: 1, strokeColor: '#ffffff', strokeWeight: 3 }, zIndex: 20 });
        if (options.pan) { map.panTo({lat:store.lat,lng:store.lng}); map.setZoom(15); }
      }
      if (options.list) {
        setView('list');
        store.card.scrollIntoView({block:'nearest',behavior:reducedMotion()?'auto':'smooth'});
        if (options.focus) store.card.querySelector('[data-select-store]').focus({preventScroll:true});
      }
    }
    function fitMap() {
      if (!map || !visible.length) return;
      const bounds = new maps.LatLngBounds();
      visible.forEach(s => bounds.extend({lat:s.lat,lng:s.lng}));
      map.fitBounds(bounds, {top:45,right:35,bottom:190,left:35});
      if (visible.length === 1) map.setZoom(15);
    }
    function filter() {
      const term = normalize(search.value.trim());
      visible = stores.filter(s => (zone === 'all' || s.region === zone) && s.search.includes(term));
      stores.forEach(s => {
        s.card.hidden = !visible.includes(s);
        if (map) { const feature = map.data.getFeatureById(s.id); if (feature) feature.setProperty('visible', !s.card.hidden); }
      });
      count.textContent = visible.length + (visible.length === 1 ? ' ubicación' : ' ubicaciones') + (visible.length < stores.length ? ' de ' + stores.length : '');
      empty.hidden = visible.length > 0;
      if (!visible.includes(selected)) selectStore(visible[0]);
      selectedPanel.hidden = !map || !visible.length;
      fitMap();
    }
    async function loadMap() {
      if (map || loading) return;
      loading = true;
      try {
        maps = await mapsLibrary(root.dataset.mapKey);
        map = new maps.Map(mapBox, {center:{lat:-25.3,lng:-57.55},zoom:11,mapTypeControl:false,streetViewControl:false,fullscreenControl:true,gestureHandling:'cooperative',clickableIcons:false});
        map.data.addGeoJson({type:'FeatureCollection',features:stores.filter(s=>Number.isFinite(s.lat)&&Number.isFinite(s.lng)).map(s=>({type:'Feature',id:s.id,properties:{name:s.name,visible:!s.card.hidden},geometry:{type:'Point',coordinates:[s.lng,s.lat]}}))});
        map.data.setStyle(feature => ({visible:feature.getProperty('visible'),title:feature.getProperty('name'),icon:{path:maps.SymbolPath.CIRCLE,scale:7,fillColor:'#181818',fillOpacity:1,strokeColor:'#fff',strokeWeight:2}}));
        map.data.addListener('click', event => { const store = stores.find(s=>s.id===event.feature.getId()); selectStore(store,{list:true}); });
        mapStatus.hidden = true;
        selectStore(visible.includes(selected) ? selected : visible[0]);
        fitMap();
        mapBox.dataset.mapReady = 'true';
      } catch (_) {
        mapStatus.querySelector('h2').textContent = 'Encontrá tu sucursal';
        mapStatus.querySelector('p').textContent = 'El mapa no pudo cargarse. Los botones «Cómo llegar» abren cada ubicación en Google Maps.';
        mapBox.dataset.mapReady = 'false';
      }
    }
    function setView(view) {
      root.dataset.view = view;
      root.querySelectorAll('[data-view]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.view===view)));
      if (view === 'map') { loadMap(); if (map) window.setTimeout(fitMap,50); }
    }
    function permitted(purpose) {
      try {
        const privacy=window.Shopify && window.Shopify.customerPrivacy;
        const method=purpose==='analytics'?'analyticsProcessingAllowed':'marketingAllowed';
        return Boolean(privacy && typeof privacy[method]==='function' && privacy[method]());
      } catch (_) { return false; }
    }
    function trackAction(link, store) {
      const mode = root.dataset.trackingMode;
      if (mode === 'off' || !mode || (window.Shopify && window.Shopify.designMode)) return;
      const action = link.dataset.storeAction;
      const eventName = action==='whatsapp'?'tl_store_whatsapp_click':'tl_store_directions_click';
      const detail = {store_id:store.id,store_name:store.name,store_region:store.region,contact_index:link.dataset.contact||'0',page_type:'store_locator'};
      if (mode === 'events') {
        if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish==='function') {
          try { const result=window.Shopify.analytics.publish(eventName,detail); if (result && typeof result.catch==='function') result.catch(()=>{}); } catch (_) { /* Navigation must still work. */ }
        }
        return;
      }
      if (mode !== 'direct') return;
      if (permitted('analytics') && typeof window.gtag==='function' && /^G-[A-Z0-9]+$/.test(root.dataset.ga4Id||'')) {
        try { window.gtag('event',eventName,{...detail,send_to:root.dataset.ga4Id,transport_type:'beacon'}); } catch (_) { /* Keep contact links usable. */ }
      }
      if (permitted('marketing') && typeof window.fbq==='function' && /^\d+$/.test(root.dataset.metaId||'')) {
        try { window.fbq('trackSingleCustom',root.dataset.metaId,action==='whatsapp'?'TLStoreWhatsAppClick':'TLStoreDirectionsClick',detail); } catch (_) { /* Keep contact links usable. */ }
      }
    }
    if (window.Shopify && typeof window.Shopify.loadFeatures==='function' && !window.Shopify.customerPrivacy) {
      window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],()=>{});
    }
    search.addEventListener('input',filter);
    root.querySelectorAll('[data-zone]').forEach(button=>button.addEventListener('click',()=>{
      zone=button.dataset.zone;
      root.querySelectorAll('[data-zone]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
      filter();
    }));
    root.querySelectorAll('[data-view]').forEach(button=>button.addEventListener('click',()=>setView(button.dataset.view)));
    root.querySelector('[data-map-reset]').addEventListener('click',()=>{zone='all';search.value='';root.querySelectorAll('[data-zone]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.zone==='all')));filter();setView('map');});
    root.querySelector('[data-map-card-link]').addEventListener('click',()=>selectStore(selected,{list:true,focus:true}));
    stores.forEach(store=>{
      store.card.querySelector('[data-select-store]').addEventListener('click',()=>{
        selectStore(store,{pan:true});setView('map');
        if (window.matchMedia('(max-width:700px)').matches) root.querySelector('[data-map-column]').scrollIntoView({block:'nearest',behavior:reducedMotion()?'auto':'smooth'});
      });
      store.card.querySelectorAll('[data-store-action]').forEach(link=>link.addEventListener('click',()=>trackAction(link,store)));
    });
    selectStore(selected);
    if (window.matchMedia('(min-width:701px)').matches) {
      if ('IntersectionObserver' in window) { const observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){observer.disconnect();loadMap();}},{rootMargin:'150px'});observer.observe(mapBox); }
      else loadMap();
    }
    root.dataset.locatorReady='true';
  }
  function boot(scope=document) { scope.querySelectorAll('[data-tl-locator]').forEach(initialize); }
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>boot(),{once:true}); else boot();
  document.addEventListener('shopify:section:load',event=>boot(event.target));
})();


  } catch(e) { console.error(e); }
})();
})();
